// Stripe subscription status types based on Stripe API documentation
export type StripeSubscriptionStatus =
  | 'active'
  | 'canceled'
  | 'incomplete'
  | 'incomplete_expired'
  | 'past_due'
  | 'paused'
  | 'trialing'
  | 'unpaid';

export const SUBSCRIPTION_ACTIVE_STATUSES = ['active', 'trialing'] as StripeSubscriptionStatus[];

export interface CampaignLimits {
  currentActiveCount: number;
  maxActiveAllowed: number;
  canCreateMore: boolean;
}

export interface User {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  auth0Id: string;
  lastLogin?: Date;
  discordId?: string;
  discordUsername?: string;
  discordAvatar?: string;
  linkedProviders?: string[];
  primaryProvider?: string;
  googleId?: string;
  googleAvatar?: string;
  hasEmailPassword?: boolean;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
  sessions?: unknown[];
  players?: User[];
  dungeonMasters?: User[];
  mainUser?: User;
  stripeSubscriptionStatus?: StripeSubscriptionStatus;
  isAdmin?: boolean;
  compendiumCampaignId?: string | null;
}

export type AiProvider = 'openai' | 'anthropic';

export const AI_PROVIDER_LABELS: Record<AiProvider, string> = {
  openai: 'OpenAI',
  anthropic: 'Anthropic (Claude)'
};

export type ThemeBrand = 'ark-flame' | 'ark-classic';

export interface UserSettings {
  sendRequesterLeaveWarning?: boolean;
  showReferralLinkOnSharedPages?: boolean;
  autoApplySmallEdits?: boolean;
  aiProvider?: AiProvider;
  themeBrand?: ThemeBrand;
  [key: string]: unknown;
}
